<template>
	<div id='ae' class='' v-loading='loading'>
		<div class='gPageBorder'>
			<div
				style='width:140px;height:140px;margin:24px 24px 24px 24px;display:inline-block;float:left;overflow:hidden;'>
				<div :style="avtStyle">
					<!-- <img style='width:100%;' :src="imgFullUrl(config? config.data.appBigIcon : '')"> -->
				</div>
			</div>
			<div style='display:inline-block;width:calc(100% - 188px);height:100%;margin-bottom:0px;:'>
				<div style='height:64px;'>
					<button class='dt-word-appmain'
						style='padding:0;height:100%;font-size:22px;background:none;border:none;'>{{ config ?
							config.data.appName : '' }}</button>
				</div>
				<div style='height:60px;'>
					<table class='dt-app-app'>
						<tr>
							<td>
								<label class='dt-word-apptt'>{{ $t('app_appName') }}：</label>
								<label class='dt-word-appmain'>{{ app_detail ? app_detail.appName : '' }}</label>
							</td>
							<td>
								<label class='dt-word-apptt'>{{ $t('psp_app_version') }}：</label>
								<label class='dt-word-appmain'>{{ app_detail ? app_detail.appVersion : '' }}</label>
							</td>
							<td>
								<label class='dt-word-apptt'>{{ $t('app_ulTime') }}：</label>
								<label class='dt-word-appmain'>{{ app_detail ? app_detail.createTime : '' }}</label>
							</td>
							<td>
								<!-- <label class='dt-word-apptt'>{{$t('app_introl')}}：</label> -->
								<!-- <label class='dt-word-appmain'>{{app_detail? app_detail.memo : ''}}</label> -->
							</td>

						</tr>
						<tr>
							<td>
								<!-- <label class='dt-word-apptt'>{{$t('app_ulTime')}}：</label> -->
								<!-- <label class='dt-word-appmain'>{{app_detail? app_detail.createTime : ''}}</label> -->
							</td>
							<td>
							</td>
							<td>
							</td>
							<td></td>
						</tr>
					</table>
				</div>
				<div style='min-height:60px;display:flex;display:-webkit-flex;'>
				</div>
			</div>
		</div>


		<div class='gPageBorder gTopMg' style=''>
			<!-- <p class='gCtColor gPTitle' style=''>{{$t('app_appUpList')}} </p> -->
			<div id=''>
				<div style=''>
					<el-row>
						<el-col :span="8" class=''>
							<el-button class='gSgLeftBtn' type='primary' @click='open_push'>{{ $t('app_adddv')
							}}</el-button>
							<el-button @click="addTer" type='primary' class=''>{{ $t('app_fileImport') }}</el-button>
							<el-button type="danger" icon="" size="" :disabled="multipleSelection.length == 0"
								@click="batchDeleteRow">{{ $t('lin_btn.batch_delete') }}</el-button>
							<el-button type="danger" icon="" size="" @click="delete_all">{{ $t('app_allDel')
							}}</el-button>
						</el-col>
						<el-col :span="4">
							<div class='gCtrl'>

							</div>
						</el-col>

						<el-col :span="4">
							<div class='gCtrl'>
							</div>
						</el-col>

						<el-col :span="4">
							<div class='gCtrl'>
								<el-input :placeholder="$t('app_terNo')" v-model='uninsatll_form.terminalNo'
									@keyup.enter.native='getUnstallList' icon="search"
									:on-icon-click="getUnstallList"></el-input>
							</div>
						</el-col>


						<el-col :span="4">
							<div class='gSideCtrl'>
								<MechanismSelector style='width:100%;' :data="mechanismDatas"></MechanismSelector>
							</div>
						</el-col>

					</el-row>


				</div>
				<div id=''>
					<el-table @row-click='' :data="uninstallData" border ref="multipleTables"
						@selection-change="handleSelectionChange" class='tbPoint gTopMg'
						style="width: 100%;border:none;">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column header-align='center' align='center' prop="ternimalNo" :label="$t('app_terNo')"
							width="">
						</el-table-column>
						<el-table-column header-align='center' align='center' prop="mechName"
							:label="$t('app_distributor')" width="">
						</el-table-column>
						<el-table-column header-align='center' align='center' prop="updateStatus" width=''
							:label="$t('app_termin_status')">
							<template slot-scope='scope'>
								<span v-if="scope.row.updateStatus == 0">{{ $t('app_wite_update') }}</span>
								<span v-if="scope.row.updateStatus == 1">{{ $t('app_Update_successfully') }}</span>
								<span v-if="scope.row.updateStatus == 2">{{ $t('app_Update_failure') }}</span>
							</template>
						</el-table-column>


						<el-table-column header-align='center' align='center' prop="updateTime" width='175'
							:label="$t('app_udtime')">
						</el-table-column>

						<el-table-column header-align='center' align='center' prop="operate" width='106'
							:label="$t('app_operate')">
							<template slot-scope='scope'>
								<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
									<el-button type='text' @click='deleteApps(scope.row)'><i class="fa fa-trash"
											style="color:#FF4949"></i></el-button>
								</el-tooltip>

							</template>
						</el-table-column>
					</el-table>

					<div class="gPgDiv" style=''>
						<el-pagination class='gPg' @current-change="pageSelectUn" @size-change="pageSizedUn"
							:current-page="uninsatll_form.page" :page-sizes='$gRows' :page-size="uninsatll_form.rows"
							layout="total, sizes, prev, pager, next, jumper" :total="uninstallTotal">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog class='gDia' :title="$t('app_adddv')" v-model="show_push" @close='handleClose' size=''>
			<div v-loading='device_loading' id='' class='gBorder'>
				<el-row style=''>
					<el-col :span="24">
						<el-button type='primary' :disabled="select_device.length == 0" @click='bcPush'
							class='gSgLeftBtn'>{{
								$t('app_pushsldev') }}</el-button>
						<!-- <el-button type='primary' @click='pushAll()' style=''>{{$t('app_pushAll')}}</el-button> -->
					</el-col>
				</el-row>
				<el-row style=''>
					<el-col :span="12" style="display: flex;align-items: center;">

						<div class='gSideCtrl' style="margin-right: 8px;">
							<el-input :placeholder="$t('app_start_no')" icon='search' :on-icon-click='get_device_list'
								@keyup.enter.native='get_device_list' v-model='select_form.snBegin'></el-input>
						</div>
						<div class='gSideCtrl' style="margin-left: 0;margin-right: 0;">
							~
						</div>
						<div class='gSideCtrl'>
							<el-input :placeholder="$t('app_end_no')" icon='search' :on-icon-click='get_device_list'
								@keyup.enter.native='get_device_list' v-model='select_form.snEnd'></el-input>
						</div>
					</el-col>

					<el-col v-show='true' :offset="0" :span="4">
						<div class='gCtrl'>
							<el-select @change='getCmDv' style='' v-model="select_form.terminal_status"
								:placeholder="$t('app_status')">
								<el-option v-for="item in sstatusAr" :key="item.vl" :label="item.lb" :value="item.vl">
								</el-option>
							</el-select>
						</div>
					</el-col>

					<el-col v-show='true' :offset="0" :span="4">
						<!-- <div class='gCtrl'><el-input  :placeholder="$t('app_adname')" icon='search' :on-icon-click='query' @keyup.enter.native='query' v-model='queryKey'></el-input></div> -->
						<div class='gCtrl'>
							<MechanismSelector style='width:100%;' :data="mechanismData"></MechanismSelector>
						</div>
					</el-col>
					<el-col v-show='true' :span="4">
						<div class='gSideCtrl'>
							<el-input :placeholder="$t('app_terNo')" icon='search' :on-icon-click='get_device_list'
								@keyup.enter.native='get_device_list' v-model='select_form.terminal_no'></el-input>
						</div>
					</el-col>
				</el-row>

				<el-table class='gTopMg' ref="multipleTable" id='dpTable' :data="deviceList" border
					tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChangeDevice">
					<el-table-column type="selection" align='center' width="55">
					</el-table-column>
					<el-table-column prop="terminalNo" align='center' :label="$t('app_terNo')" width="210">
					</el-table-column>
					<el-table-column align='center' prop="terminalName" :label="$t('app_terName')" width="210">
					</el-table-column>
					<el-table-column align=center prop='terminalStatus' :formatter="mkDvSt" :label="$t('app_status')"
						width="150">
					</el-table-column>
					<el-table-column align='center' prop="mechName" :label="$t('app_distributor')" width="210">
					</el-table-column>

					<el-table-column prop="operate" :label="$t('app_operate')" align='center' width='106'>
						<template slot-scope='scope'>
							<el-tooltip class="item" effect="dark" :content="$t('lin_btn.send')" placement="top">
								<el-button @click='pushed(scope.row)' type=text><i class="fa fa-upload" style=""></i>
								</el-button>
							</el-tooltip>

						</template>
					</el-table-column>
				</el-table>

				<div class="gPgDiv">

					<el-pagination class='gPg' @current-change="pageSelectDevice" @size-change="pageSizedDevice"
						:current-page="select_form.page" :page-sizes='[20, 100]' :page-size="select_form.rows"
						layout="total, sizes, prev, pager, next, jumper" :total="deviceTotal">
					</el-pagination>
				</div>
			</div>
		</el-dialog>

		<el-dialog class='gDia' :title="$t('app_fipush')" v-model="pushImport" @close='closeImport'>
			<el-form model="" rules="">
				<el-form-item :label="$t('app_ulfile')" :label-width="formLabelWidth">

					<el-upload class="upload-demo" ref="upload" name="fileUpload" :action="ulurl()" :limit="1"
						:on-remove="beforeRemove" :before-upload="srcBefore" :on-success="srcSuccess"
						:on-error='ulError' :file-list="fileList">
						<el-button slot="trigger" size="small" type="primary">{{ $t('app_clickUpdate') }}</el-button>
						<a :href="downTpl" style="margin-left:8px;margin-right:10px;">
							<el-button type="success" size='small'>{{ $t('terminal.list.import_muban') }}</el-button>
						</a>
					</el-upload>

				</el-form-item>
				<el-form-item :label="$t('app_deviceNum')" :label-width="formLabelWidth">
					{{ uldata ? uldata.terNums : 0 + $t('app_amechine') }}
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="pushImport = false">{{ $t('app_cancel') }}</el-button>
				<el-button style="margin-left: 10px;" type="primary" @click="submitUpload">
					{{ $t('app_srpush') }}
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<style>
.dt-word-appmain {
	color: rgb(72, 87, 106)
}

.dt-word-apptt {
	color: #99A9BF;
}

pre {
	white-space: pre-wrap;
	word-wrap: break-word;
	white-space: -moz-pre-wrap;
	white-space: -pre-wrap;
	white-space: -o-pre-wrap;
	word-break: break-all;
}

.dt-app-app {
	width: 100%;
	height: 100%;
}

.dt-app-app td {
	width: 25%;
}

/* upload */
.avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.capture {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
	width: 120px;
	display: inline-block;
}

.capture div {
	float: left;
}

.avatar-uploader .el-upload:hover {
	border-color: #20a0ff;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 128px;
	height: 128px;
	line-height: 128px;
	text-align: center;
}

/* upload */
.sm-avatar-uploader-icon {
	font-size: 36px;
	color: #8c939d;
	width: 72px;
	height: 72px;
	line-height: 72px;
	text-align: center;
}

.sm-avatar {
	width: 64px;
	height: 64px;
	display: block;
}
</style>

<script>
import mm from 'moment'
import df from '../../assets/df.png'
import tyc from '@/components/global/tyc'
import MechanismSelector from '@/components/global/mechanism_selector.vue'
import tagc from '@/components/global/tagc'
import {
	baseurl,
	focusEvent,
	urlAssets
} from '../../api/url'
export default {
	components: {
		MechanismSelector,
		tyc,
		tagc
	},
	data() {
		var that = this
		return {
			downTpl: `${urlAssets.prefix}tms-server-web/model/terminalNos.xlsx`,
			uldata: '',
			formLabelWidth: '28.5%',
			pushImport: false,
			fileList: [],
			cmtStatusArr: [],
			mechanismData: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback(value) {
					that.mech = value
					that.getCmDv()
				}
			},
			multipleSelection: [],
			isNon: false,
			mech: "",
			deviceList: [],
			deviceTotal: 0,
			select_device: [],
			tqobj: '',
			device_loading: false,
			mechanismDatas: {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback(value) {
					that.uninsatll_form.mechId = value
					that.getUnstallList()
				}
			},
			sstatus: {
				'0': this.$t('app_new'),
				'1': this.$t('app_enable')
			},
			sstatusAr: [{
				vl: '',
				lb: this.$t('app_all')
			},
			{
				vl: '0',
				lb: this.$t('app_new')
			},
			{
				vl: '1',
				lb: this.$t('app_enable')
			}
			],
			uninstallData: [],
			uninstallTotal: 0,
			uninsatll_form: {
				page: 1,
				rows: 10,
				terminalNo: "",
				mechId: "",
				appId: ""
			},
			show_push: false,
			select_form: {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			},


			total: 0,
			queryKey: '',
			terminalNo: "",
			sNum: 0,
			page: 1,
			tableData1: [],
			tableData: [],
			list: [],
			pushedList: false,
			tqobj: '',
			dobj: '',
			vSt: '',
			config: '',
			captures: [],
			loading: 0,
			iconUrl: '',
			app_detail: {}
		}
	},
	computed: {
		avtStyle() {
			//this.config.data.appBigIcon
			var url = this.iconUrl ? this.imgFullUrl(this.iconUrl) : require('../../assets/df.png')

			return 'background-size: cover;background-position: center center;width:100%;height:100%;background-image: url(' +
				url + ')'
		},
	},
	methods: {
		beforeRemove() {
			this.fileList = []
			this.uldata = ''
		},
		// 上传前
		srcBefore(file) {
			if (this.uldata.fileNo) {
				return false
			}
			// window[this.$route.path] = 1
			var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
			const extension = testmsg === "xls";
			const extension2 = testmsg === "xlsx";
			if (!extension && !extension2) {
				this.$message({
					message: this.$t("IncorrectaFormat"),
					type: "warning",
				});
			}
			return extension || extension2;
		},
		// 上传成功
		srcSuccess(res, file) {
			window[this.$route.path] = ''
			//console.log(res, this.fileList)
			if (res.status === 200) {
				// this.fileList = [{
				// 	name: file.name
				// }]
				this.uldata = res.data
				// console.log('this.uldata', this.uldata)
				this.$message.success(res.message)
				// this.closeImport()
			} else {
				// this.srcList = []
				this.$message.error(res.message)
			}
		},
		// 上传失败
		ulError() {
			window[this.$route.path] = ''
		},
		ulurl() {
			var url = this.$fileExcelUlUrl + '?token=' + localStorage.user + '&language=' + localStorage.system_lang
			//  alert(url)
			return url
		},
		// 上传
		submitUpload() {
			// this.$refs.upload.submit()
			this.loading = true
			this.$pushByImport(this.app_detail.id, this.uldata.fileNo, '1', (res) => {
				// console.log(res.data)
				this.loading = false
				if (res.status === 200) {
					this.$message.success(res.message)
				} else {
					this.$message.error(res.message)
				}
			}, () => {
				this.loading = false
			})
			this.fileList = []
			this.uldata = ''
			this.getUnstallList()
			this.pushImport = false
		},
		//  打开文件导入窗口
		open_import() {
			this.pushImport = true;
		},
		// 关闭文件导入窗口
		closeImport() {
			this.pushImport = false;
			this.fileList = []
			this.uldata = ''
		},
		addTer() {
			this.pushImport = true
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		handleSelectionChangeDevice(val) {
			this.select_device = val
		},
		// 打开弹窗
		open_push() {
			this.show_push = true;
			this.getCmDv()
			// this.get_device_list()
		},
		// 关闭弹窗
		handleClose() {
			this.show_push = false;
			this.select_form = {
				page: 1,
				rows: 20,
				areaid: "",
				snBegin: "",
				snEnd: "",
				terminal_status: "",
				terminal_no: ""
			}
			var that = this;
			that.mech = ""
			this.mechanismData = {
				value: null,
				placeholder: that.$t('lin_global.place_areaid'),
				callback(value) {
					that.mech = value
					that.getCmDv()
				}
			}

		},
		// 批量推送
		bcPush() {
			var terminalNo_list = []
			var mechId_list = []
			var mechName_list = []
			this.select_device.forEach(obj => {
				terminalNo_list.push(obj.terminalNo)
				mechId_list.push(obj.mechanismId)
				mechName_list.push(obj.mechName)
			})

			var tip = this.$t('app_surepsxdv').replace('{num}', this.select_device.length)

			this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning',
				() => {
					let sub_form = {
						appId: this.app_detail.id,
						terminalNo: String(terminalNo_list),
						mechId: String(mechId_list),
						mechName: String(mechName_list),
						fileType: 2
					}
					this.device_loading = true
					this.$changePspPush(sub_form, (
						res) => {
						this.device_loading = false
						if (res.status === 200) {
							this.$message.success(res.message)
							this.show_push = false;
							this.getUnstallList()
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						// error
						this.device_loading = false
					})
				}, '')
		},
		// 推送全部
		pushAll() {
			this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t(
				'app_cancel'), 'warning', () => {
					this.select_form.areaid = this.mech
					console.log(this.select_form)
					console.log("推送全部")
					// this.loading = true
					// this.$appendPush(this.pObj.taskId, '', '1', this.mech, this.queryKey, '', terminalstats,this.snBegin,this.snEnd, (
					// 	res) => {
					// 	this.loading = false
					// 	if (res.status === 200) {
					// 		//console.log(res.data)
					// 		this.$message.success(res.message)
					// 		this.pushdev = false
					// 	} else {
					// 		this.$message.error(res.message)
					// 	}
					// }, () => {
					// 	// error
					// 	this.loading = false
					// })
				}, '')
		},
		// 单个推送
		pushed(row) {
			this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ' + row.terminalNo + ' ?', this.$t(
				'app_sure'), this.$t(
					'app_cancel'), 'warning', () => {
						console.log(row)
						let sub_form = {
							appId: this.app_detail.id,
							terminalNo: row.terminalNo,
							mechId: row.mechanismId,
							mechName: row.mechName,
							fileType: 2
						}
						this.device_loading = true
						this.$changePspPush(sub_form, (
							res) => {
							this.device_loading = false
							if (res.status === 200) {
								this.$message.success(res.message)
								this.show_push = false;
								this.getUnstallList()
							} else {
								this.$message.error(res.message)
							}
						}, () => {
							// error
							this.device_loading = false
						})
					}, '')
		},
		pageSizedDevice(vl) {
			this.select_form.rows = vl
			this.getCmDv()
		},
		pageSelectDevice(vl) {
			this.select_form.page = vl
			this.getCmDv()
		},
		pageSelectUn(index) {
			this.uninsatll_form.page = index;
			this.getUnstallList();
		},
		pageSizedUn(val) {
			this.uninsatll_form.rows = val;
			this.getUnstallList();
		},
		getCmDv() {
			var _this = this
			var typeKey = 'terminalTypes'
			this.tqobj = {
				keys: [typeKey],
				callback: (data) => {
					_this.cmtStatusArr = data[0]
				}
			}
			this.get_device_list()
		},
		mkDvSt(row) {
			return this.sstatus[row.terminalStatus]
		},
		get_device_list() {
			this.device_loading = true
			this.$getNonItDv(this.select_form.page, this.select_form.rows, this.mech, this.select_form.terminal_no,
				this.select_form.terminal_status, "", '', '', this.select_form.snBegin, this.select_form.snEnd, (
					res) => {
				this.device_loading = 0
				if (res.status === 200) {
					//console.log(res.data)
					this.deviceList = res.data
					this.deviceTotal = res.total
				} else {
					this.$message.error(res.message)
				}
			}, () => {
				// error
				this.device_loading = 0
			})
		},
		// 单个删除
		deleteApps(obj) {
			this.$showConfirm(
				this.$t("app_tip"),
				this.$t("terminal.list.delete_tips"),
				this.$t("app_sure"),
				this.$t("app_cancel"),
				"warning",
				() => {
					this.$changePspDel(
						obj.id,
						res => {
							if (res.status === 200) {
								this.$message.success(res.message);
								this.getUnstallList();
							} else {
								this.$message.error(res.message);
							}
						},
						""
					);
				},
				""
			);
		},
		// 批量删除
		batchDeleteRow() {
			//let self = this
			this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(() => {
				let ids = []
				for (let i = 0; i < this.multipleSelection.length; i++) {
					ids.push(this.multipleSelection[i].id)
				}
				this.$changePspDel(
					String(ids),
					res => {
						if (res.status === 200) {
							this.$message.success(res.message);
							this.getUnstallList();
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			}).catch(() => {

			})
		},
		// 删除全部
		delete_all() {
			//let self = this
			this.$confirm(this.$t('del_allData'), this.$t('lin_btn.tips'), {
				confirmButtonText: this.$t('lin_btn.confirm'),
				cancelButtonText: this.$t('lin_btn.cancel'),
				type: 'warning'
			}).then(() => {
				let sub_form = {
					appId: this.app_detail.id,
					terminalNo: this.uninsatll_form.terminalNo,
					mechId: this.uninsatll_form.mechId
				}
				this.$changePspDelAll(
					sub_form,
					res => {
						if (res.status === 200) {
							this.$message.success(res.message);
							this.uninsatll_form = {
								page: 1,
								rows: 20,
								terminalNo: "",
								mechId: "",
								appId: this.app_detail.id
							}
							var that = this;
							this.mechanismDatas = {
								value: null,
								placeholder: that.$t('lin_global.place_areaid'),
								callback(value) {
									that.uninsatll_form.mechId = value
									that.getUnstallList()
								}
							}
							this.getUnstallList();
						} else {
							this.$message.error(res.message);
						}
					},
					""
				);
			}).catch(() => {

			})
		},
		getUnstallList() {
			// this.loading = 1;
			this.$changePspDeviceList(this.uninsatll_form,
				res => {
					this.loading = 0;
					if (res.status === 200) {
						this.uninstallTotal = res.total;
						this.uninstallData = res.data;
					} else {
						this.$message(res.message);
					}
				},
				() => {
					// this.loading = 0;
					this.$message.error(this.$t("app_rqsError"));
				}
			);

		},
	},
	created() {
		this.config = this.$getWObj().updatePspDetail
		this.app_detail = JSON.parse(JSON.stringify(this.config.data))
		this.uninsatll_form.appId = this.app_detail.id
		if (this.config.type == 1) {
			this.show_push = true;
			this.get_device_list()
		}
		console.log(this.app_detail)
		this.getUnstallList()



	}
}
</script>


// WEBPACK FOOTER //
// updatePspDetail.vue?91704026